import { jsx as _jsx } from "react/jsx-runtime";
import { isSafari } from '@bos/utils';
import { isRem, remToPx } from '../../helpers/rem';
import { useTestIdAttribute } from '../../hooks/useTestIdAttribute';
import { iconSizeMap, getIconColor, defaultIconColor, defaultIconSize, } from './iconConst';
import { icons } from './icons';
export const Icon = ({ name, color: passedColor = defaultIconColor, size = defaultIconSize, sizeOverride, colorOverride, testId, }) => {
    const testIdAttribute = useTestIdAttribute(testId);
    const iconColor = getIconColor(passedColor);
    const nameWithMdPrefix = `Md${name}`;
    const IconComponent = icons[nameWithMdPrefix];
    // Just for safety
    if (!IconComponent)
        return null;
    const color = colorOverride || iconColor;
    const resultSize = sizeOverride || iconSizeMap[size];
    const shouldConvertToPx = isRem(resultSize) && isSafari();
    // Safari has a problem with rem sizes, so we need to convert them to px
    const finalSize = shouldConvertToPx ? remToPx(resultSize) : resultSize;
    return _jsx(IconComponent, { size: finalSize, color: color, ...testIdAttribute });
};
